import { Users } from "lucide-react";

import { useRoleAccess } from "@/features/auth/permissions/useRoleAccess";
import { CollaboratorsSelect } from "@/features/request/edit/components/collaborators-section/CollaboratorsSelect";
import { CollapsibleBox } from "@/features/request/edit/components/CollapsibleBox";
import { useTemplateLock } from "@/features/request/edit/hooks/useTemplateLock.tsx";

import { CollaboratorsView } from "./CollaboratorsView";

export function CollaboratorsSection() {
  const { canAccess } = useRoleAccess();

  const { isLocked } = useTemplateLock();
  const isViewOnly =
    canAccess("edit-request.details.designer.view") || isLocked;

  return (
    <CollapsibleBox
      icon={<Users className="text-white" size={16} />}
      iconClassName="bg-bg-error-solid"
      title="Collaborators"
    >
      {isViewOnly ? <CollaboratorsView /> : <CollaboratorsSelect />}
    </CollapsibleBox>
  );
}
